import React from "react";

export default function FileUploadMessage({ message }) {
  return <div dangerouslySetInnerHTML={{ __html: message }} />;
}
